import ben_goldscheider_1 from "../../images/artist/ben-goldscheider-detail.webp";
import capella_savaria_1 from "../../images/artist/capella-savaria-detail.jpg";
import capella_savaria_2 from "../../images/artist/capella-savaria-top-detail-2.jpg";
import die_kolner_akademie_1 from "../../images/artist/die-kolner-akademie-detail.jpg"
import die_kolner_akademie_2 from "../../images/artist/die-kolner-akademie-detail-2.jpg"
import evelyn_glennie_1 from "../../images/artist/evelyn-glennie-detail.jpg";
import giuseppe_guarrera_1 from "../../images/artist/giuseppe-guarrera-top-detail.jpg";
import hugo_ticciati_1 from "../../images/artist/hugo-ticciati-top-detail.jpg";
import jean_rondeau_1 from "../../images/artist/jean-rondeau-top-detail.jpg";
import la_venexiana_1 from "../../images/artist/la-venexiana-detail.jpg";
import la_venexiana_2 from "../../images/artist/la-venexiana-detail-2.jpg";
import mayumi_kanagawa_1 from "../../images/artist/mayumi-kanagawa-top-detail.jpg";
import nevermind_1 from "../../images/artist/nevermind-detail.jpg";
import o_modernt_1 from "../../images/artist/o-modernt-chamber-orchestra-detail.jpg";
import o_modernt_2 from "../../images/artist/o-modernt-chamber-orchestra-detail-2.jpg";
import odhecaton_1 from "../../images/artist/odhecaton-detail.jpg";
import odhecaton_2 from "../../images/artist/odhecaton-detail-2.jpg";
import scherzi_musicali_1 from "../../images/artist/scherzi-musicali-top-detail.jpg";
import scherzi_musicali_2 from "../../images/artist/scherzi-musicali-detail-2.jpg";
import soqquadro_italiano_1 from "../../images/artist/soqquadro-italiano-detail.jpg";
import vincenzo_capezzuto_1 from "../../images/artist/vincenzo-capezzuto-top-detail.jpg";

export const links = {
    "ben-goldscheider": {
        site: "https://www.bengoldscheider.com",
        videos: [
            { name: "Strauss Horn Concerto No.1 in E Flat, Op. 11", link: "https://www.youtube.com/embed/E8tBTGQHkMM" },
            { name: "Mozart Horn Concerto", link: "https://www.youtube.com/embed/CECYIobe9hw" },
            { name: "Schumann Adagio and Allegro Op.70", link: "https://www.youtube.com/embed/eAHSTUKt_4A" },
        ],
        images: [ ben_goldscheider_1 ]
    },
    "capella-savaria": {
        site: "https://www.capellasavaria.hu",
        videos: [
            { name: "Early European and Hungarian Dances", link: "https://www.youtube.com/embed/9D4I7TKz7iU" },
            { name: "W. A. Mozart: Double Concertos", link: "https://www.youtube.com/embed/Sl_W5FxlC1c" },
            { name: "Heinrich Ignaz Franz Biber: Battalia / Csata", link: "https://www.youtube.com/embed/ffbgkNRtDlM" }
        ],
        images: [ capella_savaria_1, capella_savaria_2 ]
    },
    "die-kolner-akademie": {
        site: "https://www.koelnerakademie.de",
        videos: [
            { name: "Beethoven - Eerste pianoconcert in C, op. 15 - Adagio", link: "https://www.youtube.com/embed/YNPoL-CEhhw" },
            { name: "Mozart - Piano Concerto no 24 K491  in C minor", link: "https://www.youtube.com/embed/rG_nrlNUql4" },
            { name: "Schütz - Musikalisches Exequien", link: "https://www.youtube.com/embed/7A0lBZEIkEE" }
        ],
        images: [ die_kolner_akademie_1, die_kolner_akademie_2 ]
    },
    "evelyn-glennie": {
        site: "https://www.evelyn.co.uk",
        videos: [
            { name: "Improvisation on Drums", link: "https://www.youtube.com/embed/BB4Luctf560"},
            { name: "Percussion Montage", link: "https://www.youtube.com/embed/9xsNlltrgqQ"},
            { name: "Concerto in C major RV 443, Mov 1", link: "https://www.youtube.com/embed/YMZeBJJ5JJc"}
        ],
        images: [ evelyn_glennie_1 ]
    },
    "giuseppe-guarrera": {
        site: "https://www.giuseppeguarrera-pianist.com",
        videos: [
            { name: "Rachmaninov Concerto n.2", link: "https://www.youtube.com/embed/c8CoeoyEFBY" },
        ],
        images: [ giuseppe_guarrera_1 ]
    },
    "hugo-ticciati": {
        site: "https://www.omodernt.com/hugoticciati",
        videos: [
            { name: "A. Schnelzer: Apollonian Dances (excerpt)", link: "https://www.youtube.com/embed/68gMh1v5wJI" },
            { name: "J. Sibelius: Symphony No. 1 in E minor, Op. 39 (4th Movement)", link: "https://www.youtube.com/embed/c9syJUpJORY" }
        ],
        images: [ hugo_ticciati_1 ]
    },
    "jean-rondeau": {
        site: "https://www.jean-rondeau.com",
        videos: [
            { name: "Bach's Goldberg Variations: Variation XX", link: "https://www.youtube.com/embed/-pYLEmoqtlQ" },
            { name: "Couperin: Les Barricades Mystérieuses - Concertgebouw Sessions", link: "https://www.youtube.com/embed/M33mfhQUJnM" },
            { name: "UNDR - Jean Rondeau & Tancrède Kummer live", link: "https://www.youtube.com/embed/WMVKSWhM3Kg" }
        ],
        images: [ jean_rondeau_1 ]
    },
    "la-venexiana": {
        site: "https://www.lavenexiana.net",
        videos: [
            { name: "Sussurri d’amore sulla laguna di Venezia", link: "https://www.youtube.com/embed/xMlb7O92Kzo" }
        ],
        images: [ la_venexiana_1, la_venexiana_2 ]
    },
    "mayumi-kanagawa": {
        site: "https://www.mayumikanagawa.com",
        videos: [
            { name: "Brahms Violin Concerto", link: "https://www.youtube.com/embed/W14UtXBirEw" },
        ],
        images: [mayumi_kanagawa_1]
    },
    "nevermind": {
        site: "https://www.harrisonparrott.com/artists/nevermind",
        videos: [
            { name: "Telemann - Quatuors Parisiens", link: "https://www.youtube.com/embed/KtTu-1d31ls" },
            { name: "Telemann - Chaconne", link: "https://www.youtube.com/embed/VX7CDkrYDZk" },
            { name: "Bach - Goldberg Variations, BWV 988: Aria", link: "https://www.youtube.com/embed/RQ_SrKezW4U" }
        ],
        images: [ nevermind_1 ]
    },
    "o-modernt": {
        site: "https://www.omodernt.com",
        videos: [
            { name: "Roaming Spirits (excerpts)", link: "https://www.youtube.com/embed/cUeQ3YtG2zs" }
        ],
        images: [ o_modernt_1, o_modernt_2 ]
    },
    "odhecaton": {
        site: "https://www.odhecaton.it",
        videos: [
            { name: "Aretino - In secundo nocturno: Responsorium V. O vos Omnes", link: "https://www.youtube.com/embed/aB7b0Ho6Xcg" },
            { name: "Monteverdi in San Marco", link: "https://www.youtube.com/embed/xgGTm-1BSwA" }
        ],
        images: [ odhecaton_1, odhecaton_2 ]
    },
    "scherzi-musicali": {
        site: "https://www.scherzimusicali.be",
        videos: [
            { name: "Joseph-Hector Fiocco - Jubilate Deo : Laudate nomen ejus", link: "https://www.youtube.com/embed/i8ZCn2rXzOA" },
            { name: "Ave Maria di Caccini", link: "https://www.youtube.com/embed/SX4kkL8eibQ" }
        ],
        images: [ scherzi_musicali_1, scherzi_musicali_2 ]
    },
    "soqquadro-italiano": {
        site: "https://www.soqquadroitaliano.it ",
        videos: [
            { name: "Monteverdi - Si dolce è 'l tormento", link: "https://www.youtube.com/embed/vbOEbV0KXqw" },
            { name: "Vivaldi - Cum Dederit", link: "https://www.youtube.com/embed/ikqLiRIZa18" },
            { name: "Stabat mater (trailer)", link: "https://www.youtube.com/embed/IKEHPtWgZgo" }
        ],
        images: [ soqquadro_italiano_1 ]
    },
    "vincenzo-capezzuto": {
        site: "https://www.vincenzocapezzuto.com",
        videos: [
            { name: "Silenziu d'amuri", link: "https://www.youtube.com/embed/h-J6zOQ0ZQs"},
            { name: "Lu rusciu te lu mare", link: "https://www.youtube.com/embed/CZ7htqa6pgM"},
            { name: "Fac ut ardeat", link: "https://www.youtube.com/embed/0qO0cCJ5L_I"}
        ],
        images: [ vincenzo_capezzuto_1 ]
    }
};